import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';

const FormSelect = ({ className, options, name, label, required, placeholder, ...props }) => {
  const { register } = useFormContext();

  return (
    <select
      {...register(name, { required: required ? 'This field is required' : false })}
      className={clsx(
        'order-1 md:order-2 w-full md:w-auto form-input bg-gray-900 border-0 rounded-md py-3.5 focus:ring-2 focus:ring-white pr-10 text-lg',
        className
      )}
      {...props}
    >
      {placeholder && (
        <option value='' disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default FormSelect;
